import { css } from '@emotion/react'
import styles, { typo } from '@mathflat/common/style'

const {
  colors: { borderColor, gray, red },
} = styles

const S = {
  Wrap: css`
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 24px);

    > header {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 0 0 72px;

      padding: 12px 0 12px 24px;
      border-bottom: 1px solid ${borderColor};

      > h3 {
        display: flex;
        align-items: center;

        font-weight: 700;
        ${typo.heading05};
      }

      > span {
        color: var(--Colors-Gray-600);
      }
    }

    .warning {
      color: ${red.$300};
      ${typo.caption01};

      input {
        border: 1px solid ${red.$300};
      }

      &.page-error {
        margin-top: 2px;
        margin-left: 32px;
      }
    }

    .print-body {
      display: flex;
      flex-direction: column;
      padding: 24px;
      overflow-y: auto;

      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 8px;
        overflow: hidden;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: var(--Radius-100);
        background-color: rgba(0, 0, 0, 0.2);
      }

      .row-left {
        display: flex;
        align-items: center;
        width: 108px;
        font-weight: 700;
      }

      .row-right {
        flex: 1;
        position: relative;
      }

      .print-row {
        display: flex;
        justify-content: flex-start;

        label {
          height: unset;
        }

        :not(:last-child) {
          margin-bottom: 24px;
        }

        &.select-student {
          .row-right {
            display: flex;
            align-items: center;
            .warning {
              margin-left: 8px;
            }
          }
        }

        &.print-count {
          margin-bottom: 20px;
          .row-left {
            height: 32px;
          }
          > div {
            flex: none;
          }
        }

        &.print-range {
          > p {
            height: 40px;
          }
          > div {
            display: flex;
            flex-direction: column;
          }
          label {
            height: 40px;
          }

          .range-radio {
            flex-direction: column;
            align-items: flex-start;
            label {
              margin: 0;
            }

            .all-page-range {
              color: ${gray.$800};
            }
          }

          .range-insert-area {
            display: flex;
            align-items: center;
            margin-top: 2px;
            padding-left: 32px;
            > div {
              flex: none;
              width: 264px;
            }
            > p {
              margin-left: 8px;
              color: ${gray.$700};
              ${typo.caption01};
            }
          }

          .range-option-area {
            display: flex;
            margin-top: 12px;
            padding-left: 32px;
            .range-input {
              margin-bottom: 14px;
            }

            > button:not(:last-child) {
              margin-right: 6px;
            }
          }
        }

        &.print-option {
          > div {
            display: flex;

            > label {
              label {
                height: 20px;
              }
              &:not(:last-child) {
                margin-right: 20px;
                span {
                  margin-top: 2px;
                }
              }
            }
          }
        }

        &.printer-select {
          z-index: 5;
          > p {
            height: 40px;
          }
          .print-dropdown {
            position: absolute;
            > div {
              width: 372px;
            }
          }
        }
      }
    }

    .print-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 0 0 80px;
      padding: 16px 24px 24px 24px;
      border-top: 1px solid var(--Colors-Gray-400);
      gap: 12px;

      .description {
        display: flex;
        align-items: center;

        ${typo.caption01};
        color: ${gray.$700};
      }
    }
  `,
  Worksheet: css`
    width: 528px;

    h3 {
      font-weight: 700;
    }
  `,
  Calculate: css`
    width: 528px;
  `,
}

export default S
